var _defs, _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckoutSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "checkout",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280.25 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#ea9c2e;}.cls-1{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.78,227.5h14.14v-5.88c0-6.5,5.32-11.81,12.38-11.81h20c7.08,0,13,5.31,13,11.81v5.88h14.15a12.38,12.38,0,0,1,12.38,12.38v51.24a4.17,4.17,0,0,1-4.17,4.16H111.51a4.11,4.11,0,0,1-4.11-4.1v-51.3a12.38,12.38,0,0,1,12.38-12.38ZM199.35,71.32c-12.38,0-30.65,14.13-32.42,26.51l-.59,35.38h93.71V97.83c-1.76-12.38-20.61-26.51-33-26.51m0,0A26.39,26.39,0,1,0,187,48.9h0a26,26,0,0,0,12.38,22.42M70.61,50.69A26.05,26.05,0,0,0,85.94,26.52a26.53,26.53,0,0,0-53,0h0A26.74,26.74,0,0,0,48.8,51.26m0,0C36.42,51.26,15.8,67.17,14,79L6.37,133.77a20.33,20.33,0,0,0,15.91,23c-2.35,37.72,4.71,86,4.71,129.1C27,293.5,33.48,300,41.74,300a14.35,14.35,0,0,0,14.14-14.13L60,191l3,94.91A14.34,14.34,0,0,0,77.1,300c8.25,0,14.73-6.5,14.73-14.13,0-31.27,7.67-90.77,5.31-114.93H286.35V142H113.64l-8.26-62.46C104.21,67.17,83,50.69,70.61,50.69M142.77,227.5h27.7v-5.88a3.92,3.92,0,0,0-4.13-3.53h-20a3.37,3.37,0,0,0-3.53,3.53Z",
    transform: "translate(-6.1)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.35,
    y: 172.48,
    width: 190.09,
    height: 3.39
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 84.35,
    y: 277.85,
    width: 190.09,
    height: 3.39
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutSelected);
export default __webpack_public_path__ + "static/media/checkout-selected.f58c657e4e41012ebc3ba7f1251f6e9c.svg";
export { ForwardRef as ReactComponent };